import UpdateDoctorForm from 'components/form/admin/doctor/UpdateDoctorForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'

export default class UpdateDoctor extends Component {
    render() {
        return (
            <>
             <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Update Doctor</h4>
                                <UpdateDoctorForm />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
